<template>
  <div class="switch-input">
    <input
      :id="name"
      v-model="val"
      class="switch-input__input"
      type="checkbox"
      :disabled="disabled"
      :name="name"
      :value="modelValue"
    >

    <label
      class="switch-input__label"
      :for="name"
    >
      <slot>
        <span
          v-if="label"
          class="switch-input__label-text"
        >
          {{ label }}
        </span>
      </slot>

      <button
        v-if="showInfoIcon"
        class="button button--light button--light-text button--icon button--smallest"
        type="button"
        tabindex="-1"
        @click="iconClickHandler"
      >
        <span class="icon fa fa-info" />
      </button>

      <span class="switch-input__toggle">
        <span class="switch-input__handle" />
      </span>
    </label>
  </div>
</template>



<script>
  export default {
    name: 'SwitchInput',

    props: {
      showInfoIcon: {
        type: Boolean,
        default: false
      },

      description: {
        type: String,
        default: null
      },

      label: {
        type: String,
        default: null
      },

      name: {
        type: String,
        required: true
      },

      modelValue: {
        type: Boolean,
        default: null
      },

      disabled: {
        type: Boolean,
        default: false
      }
    },

    computed: {
      val: {
        get() {
          return this.modelValue;
        },

        set(newValue) {
          this.$emit('update:modelValue', newValue);
        }
      }
    },

    methods: {
      iconClickHandler() {
        this.$openModal('notice', { description: this.description });
      }
    }
  };
</script>
